import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React, { useCallback } from 'react';
import { TUXTextFieldWIP } from '../TUXTextField/TUXTextField.js';

var _excluded = ["disabled", "onClick", "onDisabledClick"];
var TUXSelectField = function TUXSelectField(props) {
  var disabled = props.disabled,
      onClick = props.onClick,
      onDisabledClick = props.onDisabledClick,
      textFieldProps = _objectWithoutProperties(props, _excluded);

  var handleOnClick = useCallback(function () {
    if (disabled) {
      return onDisabledClick === null || onDisabledClick === void 0 ? void 0 : onDisabledClick();
    }

    onClick();
  }, [disabled, onClick, onDisabledClick]);
  return /*#__PURE__*/React.createElement(TUXTextFieldWIP, _extends({}, textFieldProps, {
    /** in case someone turns it into uncontrolled */
    defaultValue: undefined,
    disabled: disabled,
    onReadOnlyClick: handleOnClick,
    onDisabledClick: handleOnClick,
    readOnly: true
  }));
};

export { TUXSelectField };
//# sourceMappingURL=TUXSelectField.js.map
